/**
 * Emoji are loaded from json file stored in includes/app-elements/emoji-*.json
 * Emoji categories are also stored here.
 *
 * Emoji can be updated by running:
 * npm run build-emojis
 *
 * The emoji update script is in build/node.emoji.js
 * The emoji version can be changed here so we can keep emoji lists up to date.
 */


( function() {



	if ( typeof window.CustomEvent === "function" ) return false;



	function CustomEvent( event, params ) {



		params = params || { bubbles: false, cancelable: false, detail: undefined };

		var evt = document.createEvent( 'CustomEvent' );

		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );

		return evt;



	}



	CustomEvent.prototype = window.Event.prototype;



	window.CustomEvent = CustomEvent;



} )();


/**

 * String.padStart()

 * version 1.0.1

 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge

 * Basic support	57   	51      (No)	            44   	10      15

 * -----------------------------------------------------------------------------

 *

 * @see https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js

 */

if ( !String.prototype.padStart ) {



	String.prototype.padStart = function padStart( targetLength, padString ) {

		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;

		padString = String( typeof padString !== 'undefined' ? padString : ' ' );

		if ( this.length > targetLength ) {

			return String( this );

		} else {

			targetLength = targetLength - this.length;

			if ( targetLength > padString.length ) {

				padString += padString.repeat( targetLength / padString.length ); //append to original to ensure we are longer than needed

			}

			return padString.slice( 0, targetLength ) + String( this );

		}

	};



}



// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
// https://raw.githubusercontent.com/pieroxy/lz-string/master/libs/lz-string.js
//
// LZ-based compression algorithm, version 1.4.4
var LZString = ( function() {

	// private property
	var f = String.fromCharCode;
	var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
	var baseReverseDic = {};

	function getBaseValue( alphabet, character ) {
		if ( !baseReverseDic[ alphabet ] ) {
			baseReverseDic[ alphabet ] = {};
			for ( var i = 0; i < alphabet.length; i++ ) {
				baseReverseDic[ alphabet ][ alphabet.charAt( i ) ] = i;
			}
		}
		return baseReverseDic[ alphabet ][ character ];
	}

	var LZString = {
		compressToBase64: function( input ) {
			if ( input == null ) return "";
			var res = LZString._compress( input, 6, function( a ) { return keyStrBase64.charAt( a ); } );
			switch ( res.length % 4 ) { // To produce valid Base64
				default: // When could this happen ?
				case 0: return res;
				case 1: return res + "===";
				case 2: return res + "==";
				case 3: return res + "=";
			}
		},

		decompressFromBase64: function( input ) {
			if ( input == null ) return "";
			if ( input == "" ) return null;
			return LZString._decompress( input.length, 32, function( index ) { return getBaseValue( keyStrBase64, input.charAt( index ) ); } );
		},

		compressToUTF16: function( input ) {
			if ( input == null ) return "";
			return LZString._compress( input, 15, function( a ) { return f( a + 32 ); } ) + " ";
		},

		decompressFromUTF16: function( compressed ) {
			if ( compressed == null ) return "";
			if ( compressed == "" ) return null;
			return LZString._decompress( compressed.length, 16384, function( index ) { return compressed.charCodeAt( index ) - 32; } );
		},

		//compress into uint8array (UCS-2 big endian format)
		compressToUint8Array: function( uncompressed ) {
			var compressed = LZString.compress( uncompressed );
			var buf = new Uint8Array( compressed.length * 2 ); // 2 bytes per character

			for ( var i = 0, TotalLen = compressed.length; i < TotalLen; i++ ) {
				var current_value = compressed.charCodeAt( i );
				buf[ i * 2 ] = current_value >>> 8;
				buf[ i * 2 + 1 ] = current_value % 256;
			}
			return buf;
		},

		//decompress from uint8array (UCS-2 big endian format)
		decompressFromUint8Array: function( compressed ) {
			if ( compressed === null || compressed === undefined ) {
				return LZString.decompress( compressed );
			} else {
				var buf = new Array( compressed.length / 2 ); // 2 bytes per character
				for ( var i = 0, TotalLen = buf.length; i < TotalLen; i++ ) {
					buf[ i ] = compressed[ i * 2 ] * 256 + compressed[ i * 2 + 1 ];
				}

				var result = [];
				buf.forEach( function( c ) {
					result.push( f( c ) );
				} );
				return LZString.decompress( result.join( '' ) );

			}

		},


		//compress into a string that is already URI encoded
		compressToEncodedURIComponent: function( input ) {
			if ( input == null ) return "";
			return LZString._compress( input, 6, function( a ) { return keyStrUriSafe.charAt( a ); } );
		},

		//decompress from an output of compressToEncodedURIComponent
		decompressFromEncodedURIComponent: function( input ) {
			if ( input == null ) return "";
			if ( input == "" ) return null;
			input = input.replace( / /g, "+" );
			return LZString._decompress( input.length, 32, function( index ) { return getBaseValue( keyStrUriSafe, input.charAt( index ) ); } );
		},

		compress: function( uncompressed ) {
			return LZString._compress( uncompressed, 16, function( a ) { return f( a ); } );
		},
		_compress: function( uncompressed, bitsPerChar, getCharFromInt ) {
			if ( uncompressed == null ) return "";
			var i, value,
				context_dictionary = {},
				context_dictionaryToCreate = {},
				context_c = "",
				context_wc = "",
				context_w = "",
				context_enlargeIn = 2, // Compensate for the first entry which should not count
				context_dictSize = 3,
				context_numBits = 2,
				context_data = [],
				context_data_val = 0,
				context_data_position = 0,
				ii;

			for ( ii = 0; ii < uncompressed.length; ii += 1 ) {
				context_c = uncompressed.charAt( ii );
				if ( !Object.prototype.hasOwnProperty.call( context_dictionary, context_c ) ) {
					context_dictionary[ context_c ] = context_dictSize++;
					context_dictionaryToCreate[ context_c ] = true;
				}

				context_wc = context_w + context_c;
				if ( Object.prototype.hasOwnProperty.call( context_dictionary, context_wc ) ) {
					context_w = context_wc;
				} else {
					if ( Object.prototype.hasOwnProperty.call( context_dictionaryToCreate, context_w ) ) {
						if ( context_w.charCodeAt( 0 ) < 256 ) {
							for ( i = 0; i < context_numBits; i++ ) {
								context_data_val = ( context_data_val << 1 );
								if ( context_data_position == bitsPerChar - 1 ) {
									context_data_position = 0;
									context_data.push( getCharFromInt( context_data_val ) );
									context_data_val = 0;
								} else {
									context_data_position++;
								}
							}
							value = context_w.charCodeAt( 0 );
							for ( i = 0; i < 8; i++ ) {
								context_data_val = ( context_data_val << 1 ) | ( value & 1 );
								if ( context_data_position == bitsPerChar - 1 ) {
									context_data_position = 0;
									context_data.push( getCharFromInt( context_data_val ) );
									context_data_val = 0;
								} else {
									context_data_position++;
								}
								value = value >> 1;
							}
						} else {
							value = 1;
							for ( i = 0; i < context_numBits; i++ ) {
								context_data_val = ( context_data_val << 1 ) | value;
								if ( context_data_position == bitsPerChar - 1 ) {
									context_data_position = 0;
									context_data.push( getCharFromInt( context_data_val ) );
									context_data_val = 0;
								} else {
									context_data_position++;
								}
								value = 0;
							}
							value = context_w.charCodeAt( 0 );
							for ( i = 0; i < 16; i++ ) {
								context_data_val = ( context_data_val << 1 ) | ( value & 1 );
								if ( context_data_position == bitsPerChar - 1 ) {
									context_data_position = 0;
									context_data.push( getCharFromInt( context_data_val ) );
									context_data_val = 0;
								} else {
									context_data_position++;
								}
								value = value >> 1;
							}
						}
						context_enlargeIn--;
						if ( context_enlargeIn == 0 ) {
							context_enlargeIn = Math.pow( 2, context_numBits );
							context_numBits++;
						}
						delete context_dictionaryToCreate[ context_w ];
					} else {
						value = context_dictionary[ context_w ];
						for ( i = 0; i < context_numBits; i++ ) {
							context_data_val = ( context_data_val << 1 ) | ( value & 1 );
							if ( context_data_position == bitsPerChar - 1 ) {
								context_data_position = 0;
								context_data.push( getCharFromInt( context_data_val ) );
								context_data_val = 0;
							} else {
								context_data_position++;
							}
							value = value >> 1;
						}


					}
					context_enlargeIn--;
					if ( context_enlargeIn == 0 ) {
						context_enlargeIn = Math.pow( 2, context_numBits );
						context_numBits++;
					}
					// Add wc to the dictionary.
					context_dictionary[ context_wc ] = context_dictSize++;
					context_w = String( context_c );
				}
			}

			// Output the code for w.
			if ( context_w !== "" ) {
				if ( Object.prototype.hasOwnProperty.call( context_dictionaryToCreate, context_w ) ) {
					if ( context_w.charCodeAt( 0 ) < 256 ) {
						for ( i = 0; i < context_numBits; i++ ) {
							context_data_val = ( context_data_val << 1 );
							if ( context_data_position == bitsPerChar - 1 ) {
								context_data_position = 0;
								context_data.push( getCharFromInt( context_data_val ) );
								context_data_val = 0;
							} else {
								context_data_position++;
							}
						}
						value = context_w.charCodeAt( 0 );
						for ( i = 0; i < 8; i++ ) {
							context_data_val = ( context_data_val << 1 ) | ( value & 1 );
							if ( context_data_position == bitsPerChar - 1 ) {
								context_data_position = 0;
								context_data.push( getCharFromInt( context_data_val ) );
								context_data_val = 0;
							} else {
								context_data_position++;
							}
							value = value >> 1;
						}
					} else {
						value = 1;
						for ( i = 0; i < context_numBits; i++ ) {
							context_data_val = ( context_data_val << 1 ) | value;
							if ( context_data_position == bitsPerChar - 1 ) {
								context_data_position = 0;
								context_data.push( getCharFromInt( context_data_val ) );
								context_data_val = 0;
							} else {
								context_data_position++;
							}
							value = 0;
						}
						value = context_w.charCodeAt( 0 );
						for ( i = 0; i < 16; i++ ) {
							context_data_val = ( context_data_val << 1 ) | ( value & 1 );
							if ( context_data_position == bitsPerChar - 1 ) {
								context_data_position = 0;
								context_data.push( getCharFromInt( context_data_val ) );
								context_data_val = 0;
							} else {
								context_data_position++;
							}
							value = value >> 1;
						}
					}
					context_enlargeIn--;
					if ( context_enlargeIn == 0 ) {
						context_enlargeIn = Math.pow( 2, context_numBits );
						context_numBits++;
					}
					delete context_dictionaryToCreate[ context_w ];
				} else {
					value = context_dictionary[ context_w ];
					for ( i = 0; i < context_numBits; i++ ) {
						context_data_val = ( context_data_val << 1 ) | ( value & 1 );
						if ( context_data_position == bitsPerChar - 1 ) {
							context_data_position = 0;
							context_data.push( getCharFromInt( context_data_val ) );
							context_data_val = 0;
						} else {
							context_data_position++;
						}
						value = value >> 1;
					}


				}
				context_enlargeIn--;
				if ( context_enlargeIn == 0 ) {
					context_enlargeIn = Math.pow( 2, context_numBits );
					context_numBits++;
				}
			}

			// Mark the end of the stream
			value = 2;
			for ( i = 0; i < context_numBits; i++ ) {
				context_data_val = ( context_data_val << 1 ) | ( value & 1 );
				if ( context_data_position == bitsPerChar - 1 ) {
					context_data_position = 0;
					context_data.push( getCharFromInt( context_data_val ) );
					context_data_val = 0;
				} else {
					context_data_position++;
				}
				value = value >> 1;
			}

			// Flush the last char
			while ( true ) {
				context_data_val = ( context_data_val << 1 );
				if ( context_data_position == bitsPerChar - 1 ) {
					context_data.push( getCharFromInt( context_data_val ) );
					break;
				}
				else context_data_position++;
			}
			return context_data.join( '' );
		},

		decompress: function( compressed ) {
			if ( compressed == null ) return "";
			if ( compressed == "" ) return null;
			return LZString._decompress( compressed.length, 32768, function( index ) { return compressed.charCodeAt( index ); } );
		},

		_decompress: function( length, resetValue, getNextValue ) {
			var dictionary = [],
				next,
				enlargeIn = 4,
				dictSize = 4,
				numBits = 3,
				entry = "",
				result = [],
				i,
				w,
				bits, resb, maxpower, power,
				c,
				data = { val: getNextValue( 0 ), position: resetValue, index: 1 };

			for ( i = 0; i < 3; i += 1 ) {
				dictionary[ i ] = i;
			}

			bits = 0;
			maxpower = Math.pow( 2, 2 );
			power = 1;
			while ( power != maxpower ) {
				resb = data.val & data.position;
				data.position >>= 1;
				if ( data.position == 0 ) {
					data.position = resetValue;
					data.val = getNextValue( data.index++ );
				}
				bits |= ( resb > 0 ? 1 : 0 ) * power;
				power <<= 1;
			}

			switch ( next = bits ) {
				case 0:
					bits = 0;
					maxpower = Math.pow( 2, 8 );
					power = 1;
					while ( power != maxpower ) {
						resb = data.val & data.position;
						data.position >>= 1;
						if ( data.position == 0 ) {
							data.position = resetValue;
							data.val = getNextValue( data.index++ );
						}
						bits |= ( resb > 0 ? 1 : 0 ) * power;
						power <<= 1;
					}
					c = f( bits );
					break;
				case 1:
					bits = 0;
					maxpower = Math.pow( 2, 16 );
					power = 1;
					while ( power != maxpower ) {
						resb = data.val & data.position;
						data.position >>= 1;
						if ( data.position == 0 ) {
							data.position = resetValue;
							data.val = getNextValue( data.index++ );
						}
						bits |= ( resb > 0 ? 1 : 0 ) * power;
						power <<= 1;
					}
					c = f( bits );
					break;
				case 2:
					return "";
			}
			dictionary[ 3 ] = c;
			w = c;
			result.push( c );
			while ( true ) {
				if ( data.index > length ) {
					return "";
				}

				bits = 0;
				maxpower = Math.pow( 2, numBits );
				power = 1;
				while ( power != maxpower ) {
					resb = data.val & data.position;
					data.position >>= 1;
					if ( data.position == 0 ) {
						data.position = resetValue;
						data.val = getNextValue( data.index++ );
					}
					bits |= ( resb > 0 ? 1 : 0 ) * power;
					power <<= 1;
				}

				switch ( c = bits ) {
					case 0:
						bits = 0;
						maxpower = Math.pow( 2, 8 );
						power = 1;
						while ( power != maxpower ) {
							resb = data.val & data.position;
							data.position >>= 1;
							if ( data.position == 0 ) {
								data.position = resetValue;
								data.val = getNextValue( data.index++ );
							}
							bits |= ( resb > 0 ? 1 : 0 ) * power;
							power <<= 1;
						}

						dictionary[ dictSize++ ] = f( bits );
						c = dictSize - 1;
						enlargeIn--;
						break;
					case 1:
						bits = 0;
						maxpower = Math.pow( 2, 16 );
						power = 1;
						while ( power != maxpower ) {
							resb = data.val & data.position;
							data.position >>= 1;
							if ( data.position == 0 ) {
								data.position = resetValue;
								data.val = getNextValue( data.index++ );
							}
							bits |= ( resb > 0 ? 1 : 0 ) * power;
							power <<= 1;
						}
						dictionary[ dictSize++ ] = f( bits );
						c = dictSize - 1;
						enlargeIn--;
						break;
					case 2:
						return result.join( '' );
				}

				if ( enlargeIn == 0 ) {
					enlargeIn = Math.pow( 2, numBits );
					numBits++;
				}

				if ( dictionary[ c ] ) {
					entry = dictionary[ c ];
				} else {
					if ( c === dictSize ) {
						entry = w + w.charAt( 0 );
					} else {
						return null;
					}
				}
				result.push( entry );

				// Add w+entry[0] to the dictionary.
				dictionary[ dictSize++ ] = w + entry.charAt( 0 );
				enlargeIn--;

				w = entry;

				if ( enlargeIn == 0 ) {
					enlargeIn = Math.pow( 2, numBits );
					numBits++;
				}

			}
		}
	};
	return LZString;
} )();

if ( typeof define === 'function' && define.amd ) {
	define( function() { return LZString; } );
} else if ( typeof module !== 'undefined' && module != null ) {
	module.exports = LZString
} else if ( typeof angular !== 'undefined' && angular != null ) {
	angular.module( 'LZString', [] )
		.factory( 'LZString', function() {
			return LZString;
		} );
}

!function( t, r ) { "object" == typeof exports && "undefined" != typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define( r ) : ( t = "undefined" != typeof globalThis ? globalThis : t || self ).tinycolor = r() }( this, ( function() { "use strict"; function t( r ) { return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function( t ) { return typeof t } : function( t ) { return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t }, t( r ) } var r = /^\s+/, e = /\s+$/; function n( a, i ) { if ( i = i || {}, ( a = a || "" ) instanceof n ) return a; if ( !( this instanceof n ) ) return new n( a, i ); var o = function( n ) { var a = { r: 0, g: 0, b: 0 }, i = 1, o = null, h = null, s = null, f = !1, u = !1; "string" == typeof n && ( n = function( t ) { t = t.replace( r, "" ).replace( e, "" ).toLowerCase(); var n, a = !1; if ( y[ t ] ) t = y[ t ], a = !0; else if ( "transparent" == t ) return { r: 0, g: 0, b: 0, a: 0, format: "name" }; if ( n = T.rgb.exec( t ) ) return { r: n[ 1 ], g: n[ 2 ], b: n[ 3 ] }; if ( n = T.rgba.exec( t ) ) return { r: n[ 1 ], g: n[ 2 ], b: n[ 3 ], a: n[ 4 ] }; if ( n = T.hsl.exec( t ) ) return { h: n[ 1 ], s: n[ 2 ], l: n[ 3 ] }; if ( n = T.hsla.exec( t ) ) return { h: n[ 1 ], s: n[ 2 ], l: n[ 3 ], a: n[ 4 ] }; if ( n = T.hsv.exec( t ) ) return { h: n[ 1 ], s: n[ 2 ], v: n[ 3 ] }; if ( n = T.hsva.exec( t ) ) return { h: n[ 1 ], s: n[ 2 ], v: n[ 3 ], a: n[ 4 ] }; if ( n = T.hex8.exec( t ) ) return { r: w( n[ 1 ] ), g: w( n[ 2 ] ), b: w( n[ 3 ] ), a: F( n[ 4 ] ), format: a ? "name" : "hex8" }; if ( n = T.hex6.exec( t ) ) return { r: w( n[ 1 ] ), g: w( n[ 2 ] ), b: w( n[ 3 ] ), format: a ? "name" : "hex" }; if ( n = T.hex4.exec( t ) ) return { r: w( n[ 1 ] + "" + n[ 1 ] ), g: w( n[ 2 ] + "" + n[ 2 ] ), b: w( n[ 3 ] + "" + n[ 3 ] ), a: F( n[ 4 ] + "" + n[ 4 ] ), format: a ? "name" : "hex8" }; if ( n = T.hex3.exec( t ) ) return { r: w( n[ 1 ] + "" + n[ 1 ] ), g: w( n[ 2 ] + "" + n[ 2 ] ), b: w( n[ 3 ] + "" + n[ 3 ] ), format: a ? "name" : "hex" }; return !1 }( n ) ); "object" == t( n ) && ( E( n.r ) && E( n.g ) && E( n.b ) ? ( l = n.r, c = n.g, d = n.b, a = { r: 255 * A( l, 255 ), g: 255 * A( c, 255 ), b: 255 * A( d, 255 ) }, f = !0, u = "%" === String( n.r ).substr( -1 ) ? "prgb" : "rgb" ) : E( n.h ) && E( n.s ) && E( n.v ) ? ( o = H( n.s ), h = H( n.v ), a = function( t, r, e ) { t = 6 * A( t, 360 ), r = A( r, 100 ), e = A( e, 100 ); var n = Math.floor( t ), a = t - n, i = e * ( 1 - r ), o = e * ( 1 - a * r ), h = e * ( 1 - ( 1 - a ) * r ), s = n % 6, f = [ e, o, i, i, h, e ][ s ], u = [ h, e, e, o, i, i ][ s ], l = [ i, i, h, e, e, o ][ s ]; return { r: 255 * f, g: 255 * u, b: 255 * l } }( n.h, o, h ), f = !0, u = "hsv" ) : E( n.h ) && E( n.s ) && E( n.l ) && ( o = H( n.s ), s = H( n.l ), a = function( t, r, e ) { var n, a, i; function o( t, r, e ) { return e < 0 && ( e += 1 ), e > 1 && ( e -= 1 ), e < 1 / 6 ? t + 6 * ( r - t ) * e : e < .5 ? r : e < 2 / 3 ? t + ( r - t ) * ( 2 / 3 - e ) * 6 : t } if ( t = A( t, 360 ), r = A( r, 100 ), e = A( e, 100 ), 0 === r ) n = a = i = e; else { var h = e < .5 ? e * ( 1 + r ) : e + r - e * r, s = 2 * e - h; n = o( s, h, t + 1 / 3 ), a = o( s, h, t ), i = o( s, h, t - 1 / 3 ) } return { r: 255 * n, g: 255 * a, b: 255 * i } }( n.h, o, s ), f = !0, u = "hsl" ), n.hasOwnProperty( "a" ) && ( i = n.a ) ); var l, c, d; return i = x( i ), { ok: f, format: n.format || u, r: Math.min( 255, Math.max( a.r, 0 ) ), g: Math.min( 255, Math.max( a.g, 0 ) ), b: Math.min( 255, Math.max( a.b, 0 ) ), a: i } }( a ); this._originalInput = a, this._r = o.r, this._g = o.g, this._b = o.b, this._a = o.a, this._roundA = Math.round( 100 * this._a ) / 100, this._format = i.format || o.format, this._gradientType = i.gradientType, this._r < 1 && ( this._r = Math.round( this._r ) ), this._g < 1 && ( this._g = Math.round( this._g ) ), this._b < 1 && ( this._b = Math.round( this._b ) ), this._ok = o.ok } function a( t, r, e ) { t = A( t, 255 ), r = A( r, 255 ), e = A( e, 255 ); var n, a, i = Math.max( t, r, e ), o = Math.min( t, r, e ), h = ( i + o ) / 2; if ( i == o ) n = a = 0; else { var s = i - o; switch ( a = h > .5 ? s / ( 2 - i - o ) : s / ( i + o ), i ) { case t: n = ( r - e ) / s + ( r < e ? 6 : 0 ); break; case r: n = ( e - t ) / s + 2; break; case e: n = ( t - r ) / s + 4 }n /= 6 } return { h: n, s: a, l: h } } function i( t, r, e ) { t = A( t, 255 ), r = A( r, 255 ), e = A( e, 255 ); var n, a, i = Math.max( t, r, e ), o = Math.min( t, r, e ), h = i, s = i - o; if ( a = 0 === i ? 0 : s / i, i == o ) n = 0; else { switch ( i ) { case t: n = ( r - e ) / s + ( r < e ? 6 : 0 ); break; case r: n = ( e - t ) / s + 2; break; case e: n = ( t - r ) / s + 4 }n /= 6 } return { h: n, s: a, v: h } } function o( t, r, e, n ) { var a = [ S( Math.round( t ).toString( 16 ) ), S( Math.round( r ).toString( 16 ) ), S( Math.round( e ).toString( 16 ) ) ]; return n && a[ 0 ].charAt( 0 ) == a[ 0 ].charAt( 1 ) && a[ 1 ].charAt( 0 ) == a[ 1 ].charAt( 1 ) && a[ 2 ].charAt( 0 ) == a[ 2 ].charAt( 1 ) ? a[ 0 ].charAt( 0 ) + a[ 1 ].charAt( 0 ) + a[ 2 ].charAt( 0 ) : a.join( "" ) } function h( t, r, e, n ) { return [ S( R( n ) ), S( Math.round( t ).toString( 16 ) ), S( Math.round( r ).toString( 16 ) ), S( Math.round( e ).toString( 16 ) ) ].join( "" ) } function s( t, r ) { r = 0 === r ? 0 : r || 10; var e = n( t ).toHsl(); return e.s -= r / 100, e.s = k( e.s ), n( e ) } function f( t, r ) { r = 0 === r ? 0 : r || 10; var e = n( t ).toHsl(); return e.s += r / 100, e.s = k( e.s ), n( e ) } function u( t ) { return n( t ).desaturate( 100 ) } function l( t, r ) { r = 0 === r ? 0 : r || 10; var e = n( t ).toHsl(); return e.l += r / 100, e.l = k( e.l ), n( e ) } function c( t, r ) { r = 0 === r ? 0 : r || 10; var e = n( t ).toRgb(); return e.r = Math.max( 0, Math.min( 255, e.r - Math.round( -r / 100 * 255 ) ) ), e.g = Math.max( 0, Math.min( 255, e.g - Math.round( -r / 100 * 255 ) ) ), e.b = Math.max( 0, Math.min( 255, e.b - Math.round( -r / 100 * 255 ) ) ), n( e ) } function d( t, r ) { r = 0 === r ? 0 : r || 10; var e = n( t ).toHsl(); return e.l -= r / 100, e.l = k( e.l ), n( e ) } function g( t, r ) { var e = n( t ).toHsl(), a = ( e.h + r ) % 360; return e.h = a < 0 ? 360 + a : a, n( e ) } function b( t ) { var r = n( t ).toHsl(); return r.h = ( r.h + 180 ) % 360, n( r ) } function m( t, r ) { if ( isNaN( r ) || r <= 0 ) throw new Error( "Argument to polyad must be a positive number" ); for ( var e = n( t ).toHsl(), a = [ n( t ) ], i = 360 / r, o = 1; o < r; o++ )a.push( n( { h: ( e.h + o * i ) % 360, s: e.s, l: e.l } ) ); return a } function p( t ) { var r = n( t ).toHsl(), e = r.h; return [ n( t ), n( { h: ( e + 72 ) % 360, s: r.s, l: r.l } ), n( { h: ( e + 216 ) % 360, s: r.s, l: r.l } ) ] } function _( t, r, e ) { r = r || 6, e = e || 30; var a = n( t ).toHsl(), i = 360 / e, o = [ n( t ) ]; for ( a.h = ( a.h - ( i * r >> 1 ) + 720 ) % 360; --r; )a.h = ( a.h + i ) % 360, o.push( n( a ) ); return o } function v( t, r ) { r = r || 6; for ( var e = n( t ).toHsv(), a = e.h, i = e.s, o = e.v, h = [], s = 1 / r; r--; )h.push( n( { h: a, s: i, v: o } ) ), o = ( o + s ) % 1; return h } n.prototype = { isDark: function() { return this.getBrightness() < 128 }, isLight: function() { return !this.isDark() }, isValid: function() { return this._ok }, getOriginalInput: function() { return this._originalInput }, getFormat: function() { return this._format }, getAlpha: function() { return this._a }, getBrightness: function() { var t = this.toRgb(); return ( 299 * t.r + 587 * t.g + 114 * t.b ) / 1e3 }, getLuminance: function() { var t, r, e, n = this.toRgb(); return t = n.r / 255, r = n.g / 255, e = n.b / 255, .2126 * ( t <= .03928 ? t / 12.92 : Math.pow( ( t + .055 ) / 1.055, 2.4 ) ) + .7152 * ( r <= .03928 ? r / 12.92 : Math.pow( ( r + .055 ) / 1.055, 2.4 ) ) + .0722 * ( e <= .03928 ? e / 12.92 : Math.pow( ( e + .055 ) / 1.055, 2.4 ) ) }, setAlpha: function( t ) { return this._a = x( t ), this._roundA = Math.round( 100 * this._a ) / 100, this }, toHsv: function() { var t = i( this._r, this._g, this._b ); return { h: 360 * t.h, s: t.s, v: t.v, a: this._a } }, toHsvString: function() { var t = i( this._r, this._g, this._b ), r = Math.round( 360 * t.h ), e = Math.round( 100 * t.s ), n = Math.round( 100 * t.v ); return 1 == this._a ? "hsv(" + r + ", " + e + "%, " + n + "%)" : "hsva(" + r + ", " + e + "%, " + n + "%, " + this._roundA + ")" }, toHsl: function() { var t = a( this._r, this._g, this._b ); return { h: 360 * t.h, s: t.s, l: t.l, a: this._a } }, toHslString: function() { var t = a( this._r, this._g, this._b ), r = Math.round( 360 * t.h ), e = Math.round( 100 * t.s ), n = Math.round( 100 * t.l ); return 1 == this._a ? "hsl(" + r + ", " + e + "%, " + n + "%)" : "hsla(" + r + ", " + e + "%, " + n + "%, " + this._roundA + ")" }, toHex: function( t ) { return o( this._r, this._g, this._b, t ) }, toHexString: function( t ) { return "#" + this.toHex( t ) }, toHex8: function( t ) { return function( t, r, e, n, a ) { var i = [ S( Math.round( t ).toString( 16 ) ), S( Math.round( r ).toString( 16 ) ), S( Math.round( e ).toString( 16 ) ), S( R( n ) ) ]; if ( a && i[ 0 ].charAt( 0 ) == i[ 0 ].charAt( 1 ) && i[ 1 ].charAt( 0 ) == i[ 1 ].charAt( 1 ) && i[ 2 ].charAt( 0 ) == i[ 2 ].charAt( 1 ) && i[ 3 ].charAt( 0 ) == i[ 3 ].charAt( 1 ) ) return i[ 0 ].charAt( 0 ) + i[ 1 ].charAt( 0 ) + i[ 2 ].charAt( 0 ) + i[ 3 ].charAt( 0 ); return i.join( "" ) }( this._r, this._g, this._b, this._a, t ) }, toHex8String: function( t ) { return "#" + this.toHex8( t ) }, toRgb: function() { return { r: Math.round( this._r ), g: Math.round( this._g ), b: Math.round( this._b ), a: this._a } }, toRgbString: function() { return 1 == this._a ? "rgb(" + Math.round( this._r ) + ", " + Math.round( this._g ) + ", " + Math.round( this._b ) + ")" : "rgba(" + Math.round( this._r ) + ", " + Math.round( this._g ) + ", " + Math.round( this._b ) + ", " + this._roundA + ")" }, toPercentageRgb: function() { return { r: Math.round( 100 * A( this._r, 255 ) ) + "%", g: Math.round( 100 * A( this._g, 255 ) ) + "%", b: Math.round( 100 * A( this._b, 255 ) ) + "%", a: this._a } }, toPercentageRgbString: function() { return 1 == this._a ? "rgb(" + Math.round( 100 * A( this._r, 255 ) ) + "%, " + Math.round( 100 * A( this._g, 255 ) ) + "%, " + Math.round( 100 * A( this._b, 255 ) ) + "%)" : "rgba(" + Math.round( 100 * A( this._r, 255 ) ) + "%, " + Math.round( 100 * A( this._g, 255 ) ) + "%, " + Math.round( 100 * A( this._b, 255 ) ) + "%, " + this._roundA + ")" }, toName: function() { return 0 === this._a ? "transparent" : !( this._a < 1 ) && ( M[ o( this._r, this._g, this._b, !0 ) ] || !1 ) }, toFilter: function( t ) { var r = "#" + h( this._r, this._g, this._b, this._a ), e = r, a = this._gradientType ? "GradientType = 1, " : ""; if ( t ) { var i = n( t ); e = "#" + h( i._r, i._g, i._b, i._a ) } return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + r + ",endColorstr=" + e + ")" }, toString: function( t ) { var r = !!t; t = t || this._format; var e = !1, n = this._a < 1 && this._a >= 0; return r || !n || "hex" !== t && "hex6" !== t && "hex3" !== t && "hex4" !== t && "hex8" !== t && "name" !== t ? ( "rgb" === t && ( e = this.toRgbString() ), "prgb" === t && ( e = this.toPercentageRgbString() ), "hex" !== t && "hex6" !== t || ( e = this.toHexString() ), "hex3" === t && ( e = this.toHexString( !0 ) ), "hex4" === t && ( e = this.toHex8String( !0 ) ), "hex8" === t && ( e = this.toHex8String() ), "name" === t && ( e = this.toName() ), "hsl" === t && ( e = this.toHslString() ), "hsv" === t && ( e = this.toHsvString() ), e || this.toHexString() ) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString() }, clone: function() { return n( this.toString() ) }, _applyModification: function( t, r ) { var e = t.apply( null, [ this ].concat( [].slice.call( r ) ) ); return this._r = e._r, this._g = e._g, this._b = e._b, this.setAlpha( e._a ), this }, lighten: function() { return this._applyModification( l, arguments ) }, brighten: function() { return this._applyModification( c, arguments ) }, darken: function() { return this._applyModification( d, arguments ) }, desaturate: function() { return this._applyModification( s, arguments ) }, saturate: function() { return this._applyModification( f, arguments ) }, greyscale: function() { return this._applyModification( u, arguments ) }, spin: function() { return this._applyModification( g, arguments ) }, _applyCombination: function( t, r ) { return t.apply( null, [ this ].concat( [].slice.call( r ) ) ) }, analogous: function() { return this._applyCombination( _, arguments ) }, complement: function() { return this._applyCombination( b, arguments ) }, monochromatic: function() { return this._applyCombination( v, arguments ) }, splitcomplement: function() { return this._applyCombination( p, arguments ) }, triad: function() { return this._applyCombination( m, [ 3 ] ) }, tetrad: function() { return this._applyCombination( m, [ 4 ] ) } }, n.fromRatio = function( r, e ) { if ( "object" == t( r ) ) { var a = {}; for ( var i in r ) r.hasOwnProperty( i ) && ( a[ i ] = "a" === i ? r[ i ] : H( r[ i ] ) ); r = a } return n( r, e ) }, n.equals = function( t, r ) { return !( !t || !r ) && n( t ).toRgbString() == n( r ).toRgbString() }, n.random = function() { return n.fromRatio( { r: Math.random(), g: Math.random(), b: Math.random() } ) }, n.mix = function( t, r, e ) { e = 0 === e ? 0 : e || 50; var a = n( t ).toRgb(), i = n( r ).toRgb(), o = e / 100; return n( { r: ( i.r - a.r ) * o + a.r, g: ( i.g - a.g ) * o + a.g, b: ( i.b - a.b ) * o + a.b, a: ( i.a - a.a ) * o + a.a } ) }, n.readability = function( t, r ) { var e = n( t ), a = n( r ); return ( Math.max( e.getLuminance(), a.getLuminance() ) + .05 ) / ( Math.min( e.getLuminance(), a.getLuminance() ) + .05 ) }, n.isReadable = function( t, r, e ) { var a, i, o = n.readability( t, r ); switch ( i = !1, ( a = function( t ) { var r, e; r = ( ( t = t || { level: "AA", size: "small" } ).level || "AA" ).toUpperCase(), e = ( t.size || "small" ).toLowerCase(), "AA" !== r && "AAA" !== r && ( r = "AA" ); "small" !== e && "large" !== e && ( e = "small" ); return { level: r, size: e } }( e ) ).level + a.size ) { case "AAsmall": case "AAAlarge": i = o >= 4.5; break; case "AAlarge": i = o >= 3; break; case "AAAsmall": i = o >= 7 }return i }, n.mostReadable = function( t, r, e ) { var a, i, o, h, s = null, f = 0; i = ( e = e || {} ).includeFallbackColors, o = e.level, h = e.size; for ( var u = 0; u < r.length; u++ )( a = n.readability( t, r[ u ] ) ) > f && ( f = a, s = n( r[ u ] ) ); return n.isReadable( t, s, { level: o, size: h } ) || !i ? s : ( e.includeFallbackColors = !1, n.mostReadable( t, [ "#fff", "#000" ], e ) ) }; var y = n.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }, M = n.hexNames = function( t ) { var r = {}; for ( var e in t ) t.hasOwnProperty( e ) && ( r[ t[ e ] ] = e ); return r }( y ); function x( t ) { return t = parseFloat( t ), ( isNaN( t ) || t < 0 || t > 1 ) && ( t = 1 ), t } function A( t, r ) { ( function( t ) { return "string" == typeof t && -1 != t.indexOf( "." ) && 1 === parseFloat( t ) } )( t ) && ( t = "100%" ); var e = function( t ) { return "string" == typeof t && -1 != t.indexOf( "%" ) }( t ); return t = Math.min( r, Math.max( 0, parseFloat( t ) ) ), e && ( t = parseInt( t * r, 10 ) / 100 ), Math.abs( t - r ) < 1e-6 ? 1 : t % r / parseFloat( r ) } function k( t ) { return Math.min( 1, Math.max( 0, t ) ) } function w( t ) { return parseInt( t, 16 ) } function S( t ) { return 1 == t.length ? "0" + t : "" + t } function H( t ) { return t <= 1 && ( t = 100 * t + "%" ), t } function R( t ) { return Math.round( 255 * parseFloat( t ) ).toString( 16 ) } function F( t ) { return w( t ) / 255 } var C, q, N, T = ( q = "[\\s|\\(]+(" + ( C = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)" ) + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")\\s*\\)?", N = "[\\s|\\(]+(" + C + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")\\s*\\)?", { CSS_UNIT: new RegExp( C ), rgb: new RegExp( "rgb" + q ), rgba: new RegExp( "rgba" + N ), hsl: new RegExp( "hsl" + q ), hsla: new RegExp( "hsla" + N ), hsv: new RegExp( "hsv" + q ), hsva: new RegExp( "hsva" + N ), hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ } ); function E( t ) { return !!T.CSS_UNIT.exec( t ) } return n } ) );


/**
 * Deep clone a multi dimensional array.
 *
 * @return {array}
 */
Array.prototype.clone = function() {

	let arr = this.slice( 0 );

	for ( let i = 0; i < this.length; i++ ) {
		if ( this[ i ].clone ) {
			// Recursion.
			arr[ i ] = this[ i ].clone();
		}
	}

	return arr;

};


/**
 * Create a unique array.
 *
 * @return {array}
 */
Array.prototype.unique = function() {

	return [ ...new Set( this ) ];

};


/**
 * Like scrollIntoView but only scroll horizontally.
 *
 * @param {object} element The element to scroll.
 * @param {object} container The container to scroll within.
 * @return {void}
 */
const scrollToCenter = function( element, container ) {

	const elementCenter = element.offsetLeft + ( element.clientWidth / 2 );
	const containerWidth = container.clientWidth;

	container.scrollLeft = elementCenter - ( containerWidth / 2 );

};


/**
 * Like scrollIntoView but only scroll vertically.
 *
 * @param {object} element The element to scroll.
 * @param {object} container The container to scroll within.
 * @return {void}
 */
const scrollToTop = function( element, container ) {

	const elementTop = element.offsetTop;
	const containerTop = container.offsetTop;

	container.scrollTop = elementTop - containerTop;

};
/**
 * Share content with the Twitter intent api.
 *
 * @url https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
 *
 * @param {string} text The text to share.
 * @param {string|null} url The url to use. If null then it uses the current page url.
 * @return {string}
 */
const twitterShare = function( text, url = null ) {

	const intent = 'https://twitter.com/intent/tweet/?';

	/**
	 * This is long, but it keeps things dynamic so that it can be edited in a
	 * single place.
	 * Just in case I ever create a stand alone Twitter account.
	 */
	const via = document.querySelector( 'meta[name="twitter:site"]' )
		.getAttribute( 'content' )
		.replace( '@', '' );
	const hashtags = 'brushninja';

	if ( null === url ) {
		url = window.location.href;
	}

	const params = {
		text,
		url,
		hashtags,
		via,
	};

	let share_url = intent;

	Object.entries( params ).forEach(
		( [ key, value ] ) => {
			share_url += key + '=' + encodeURIComponent( value ) + '&';
		}
	);

	return share_url;

};




const shareModal = {

	shareOptions: {
		facebook: {
			title: 'Share on Facebook',
			label: 'Share',
			url: 'https://facebook.com/sharer/sharer.php?u=%u',
			color: '3b5998'
		},
		twitter: {
			title: 'Tweet on Twitter',
			label: 'Tweet',
			url: 'https://twitter.com/intent/tweet?text=%m',
			color: '1da1f2'
		},
		reddit: {
			title: 'Share on Reddit',
			label: 'Share',
			url: 'https://reddit.com/submit?url=%u',
			color: 'ff4500'
		},
		tumblr: {
			title: 'Share on Tumblr',
			label: 'Share',
			url: 'https://tumblr.com/widgets/share/tool?canonicalUrl=%u&content=%m',
			color: '35465c'
		},
		email: {
			title: 'Send via Email',
			label: 'Send',
			url: 'mailto:somebody@example.com?body=%m',
			color: '483d8b'
		}
	},

	/**
	 * The message to share.
	 * The following placeholders can be used:
	 * %s will be replaced with the current url.
	 * %u will be replaced with the current url.
	 * %m will be replaced with the message.
	 */
	message: 'I just created some cool art with Brush Ninja! 🎨🖌️ It\'s a fun and easy-to-use tool that works right in your browser. No sign up needed. Start Creating! %s',

	/**
	 * The url to share.
	 */
	shareUrl: '',


	/**
	 *
	 */
	show: function( title = 'Saved', content = '' ) {

		const share_m = modal.showGeneral( title );

		share_m.innerHTML = shareModal.template( content );

		// Generate the share url.
		shareModal.setUrl();

	},


	/**
	 * The share template.
	 *
	 * @param {string} content
	 * @return {string}
	 */
	template: function( content = '', closeButton = true ) {

		if ( content.length ) {
			content = `<div class="f4 m-y4 f-fw700">${content}</div>`;
		}

		shareModal.setUrl();

		let shareButtons = '';

		// Loop through shareModal.shareOptions and create javascript links
		Object.keys( shareModal.shareOptions ).forEach(
			function( shareOption ) {

				const share = shareModal.shareOptions[ shareOption ];

				const styles = [
					'-webkit-mask: center no-repeat;',
					'mask: center no-repeat;',
					'-webkit-mask-size: contain;',
					'mask-size: contain;',
					`-webkit-mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					`mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					'background: white;',
					'width: 1.5rem;',
					'height: 1.5rem;',
				];

				shareButtons += `
				<a
					class="bg-${shareOption} f-fw700 p2 b-br1 flex-g1 flex flex-jc-c flex-ai-c"
					style="background: #${share.color}; color: #fff;"
					href="${sanitize.attr( shareModal.processUrl( share.url ) )}"
					target="_blank"
					rel="noopener"
					title="${share.title}">
					<span class="icon-mask" style="${styles.join( ' ' )}"></span>
					<span class="screen-reader-text">${share.label}</span>
				</a>`;

			}
		);

		return `
			${content}
			<div class="bg-yellow b-br2 p4">
				<h2 class="f-fw700 m-y2 fg-black f4">Proud of your Brush Ninja creation?</h2>
				<p class="m-y2">Share it with your friends ⬇️</p>
				<div class="flex gap2 m-y3">${shareButtons}</div>
			</div>
			${closeButton ? '<button class="bg-blue f-fw700 m-t4" onclick="modal.close()">Create More &rarr;</button>' : ''}
		`;

		// <div class="b p2 b-br1 m-y3">${sanitize.html( shareModal.message.replace( '%s', window.location.href ) )}</div>

		// 	<div class="flex gap2 m-y4">
		// 	<input class="flex-g1 m0" value="${sanitize.url( window.location.href )}" readonly>
		// 	<button class="bg-blue f-fw700" onclick="shareModal.copyLink()">Copy url</button>
		// </div>

	},


	/**
	 * Process the url.
	 *
	 * @param {string} url
	 * @return {string}
	 */
	processUrl: function( url ) {

		shareModal.setUrl();

		const message = shareModal.message.replace( '%s', shareModal.shareUrl );

		url = url.replace( '%u', encodeURIComponent( shareModal.shareUrl ) );
		url = url.replace( '%m', encodeURIComponent( message ) );

		return url;

	},


	/**
	 * Generate the shareUrl value.
	 *
	 * @return {void}
	 */
	setUrl: function() {

		if ( shareModal.shareUrl.length ) {
			return;
		}

		// Get canonical url.
		const canonical = document.querySelector( 'link[rel="canonical"]' );

		if ( canonical ) {
			shareModal.shareUrl = canonical.href;
			return;
		}

		shareModal.shareUrl = window.location.href;

	},

};




const dimensions = {

	'square': {
		'label': 'Square Canvas (1:1)',
		'description': `Classic Brush Ninja, great for Instagram.`,
		'size': [ 512, 512 ],
	},
	'comic': {
		'label': 'Comic Maker Page',
		'description': `Make images that can be used in the Brush Ninja Comic Maker.`,
		'size': [ 210 * 2, 287 * 2 ],
	},
	'traditional': {
		'label': 'Traditional TV (4:3)',
		'description': `For that retro tv look. Works well on Twitter and Facebook.`,
		'size': [ 600, 450 ],
	},
	'widescreen': {
		'label': 'Widescreen TV (16:9)',
		'description': `For dramatic movie style creations.`,
		'size': [ 700, 390 ],
	},
	'cinema': {
		'label': 'Cinema',
		'description': `Half the size of an HD resolution - 1920x1080`,
		'size': [ 960, 540 ],
	},

};

const emoji_icons = [
	'😃', '🙁', '😇', '😂', '🥸', '😸', '💯', '❤️',
	'🎁', '🍕', '💩', '👍', '🥑', '🌈', '🦄', '🌻'
];

const paletteLibrary = {
	'default': {
		name: 'Default',
		premium: false,
		p: [
			'#ffffff', // white.
			'#999999', // gray.
			'#000000', // black.
			'#E06F8B', // meat.
			'#BE2633', // red.
			'#7a5226', // brown.
			'#EB8931', // orange.
			'#F7E26B', // yellow.
			'#A3CE27', // slimegreen.
			'#3d722c', // green.
			'#195d8a', // nightblue.
			'#31A2F2', // skyblue.
			'#B2DCEF', // cloudblue.
			'transparent', // ?
		]
	},
	'gray': {
		name: 'Grayscale',
		premium: false,
		p: [
			'#ffffff',
			'#dddddd',
			'#bbbbbb',
			'#999999',
			'#777777',
			'#555555',
			'#333333',
			'#111111',
			'#000000',
			'transparent',
		]
	},
	'classic': {
		name: 'Classic',
		premium: false,
		p: [
			'#ffffff', // white.
			'#999999', // gray.
			'#000000', // black.
			'#ff0000', // red.
			'#00FF00', // green.
			'#0000FF', // blue.
			'#FF00FF', // magenta.
			'#00FFFF', // cyan.
			'#FFFF00', // yellow.
			'transparent', // ?
		]
	},

	// https://creativemarket.com/Happyvector/3971906-Human-skin-tone-color-palette-set.#fullscreen
	'skin': {
		name: 'Skin Tone',
		premium: false,
		p: [
			'#f7ddc4',
			'#eed0b6',
			'#efc793',
			'#e7bc91',
			'#cb9662',
			'#ab8b64',
			'#b26949',
			'#94623d',
			'#885633',
			'#80492a',
			'#76441f',
			'#623a17',
			'#301e10',
			'transparent',
		]
	},

	'starry': {
		name: 'Starry',
		premium: true,
		credit: [ 'musthbly', 'https://lospec.com/palette-list/starry13' ],
		p: [
			'#4d456d',
			'#795389',
			'#a4628a',
			'#d38595',
			'#e9a7a3',
			'#f0d7b1',
			'#aec6a5',
			'#7ba1ab',
			'#657ba3',
			'#5a5f92',
			'#7d7db7',
			'#ad96cf',
			'#e6addd',
			'transparent',
		]
	},

	'pico8': {
		name: 'Pico 8',
		premium: true,
		credit: [ 'Pico-8 Console', 'https://www.lexaloffle.com/pico-8.php' ],
		p: [
			'#1D2B53',
			'#7E2553',
			'#008751',
			'#AB5236',
			'#5F574F',
			'#C2C3C7',
			'#FFF1E8',
			'#FF004D',
			'#FFA300',
			'#FFEC27',
			'#00E436',
			'#29ADFF',
			'#83769C',
			'#FF77A8',
			'#FFCCAA',
			'transparent',
		]
	},


	'final14': {
		name: 'Final 14',
		premium: true,
		credit: [ 'Final 14', 'https://lospec.com/palette-list/final-14' ],
		p: [
			'#ffdd84',
			'#ec955b',
			'#883a56',
			'#d95959',
			'#fc83c7',
			'#aa5ec3',
			'#443c7e',
			'#566ed0',
			'#7bb1eb',
			'#98eb77',
			'#3eca6b',
			'#49868b',
			'#10101d',
			'transparent',
		]
	},

	'pastel': {
		name: 'Pastel',
		premium: true,
		credit: [ 'Pikurā', 'https://lospec.com/palette-list/pastle-cute-minimal-lofi-colors' ],
		p: [
			'#92929c',
			'#a8b5ae',
			'#c5cfc4',
			'#cca3a3',
			'#f1b4b4',
			'#f3eded',
			'#e2e4df',
			'#96beb1',
			'#b9eedc',
			'#fbd4d2',
			'#eeb9c7',
			'#cac18a',
			'#e4dba0',
			'transparent',
		]
	},

	'sls08': {
		name: 'SLS08',
		premium: true,
		credit: [ 'Luis Miguel Maldonado', 'https://lospec.com/palette-list/slso8' ],
		p: [
			'#0d2b45',
			'#203c56',
			'#544e68',
			'#8d697a',
			'#d08159',
			'#ffaa5e',
			'#ffd4a3',
			'#ffecd6',
			'#ffffff',
			'transparent',
		]
	},

	'radioactive13': {
		name: 'Radioactive',
		premium: false,
		credit: [ 'Miguel Lucero', 'https://lospec.com/palette-list/radioactive13' ],
		p: [
			'#422c33',
			'#73514d',
			'#ac8a71',
			'#decb9f',
			'#52615d',
			'#7f8f81',
			'#bfc7af',
			'#eeecde',
			'#2a3a42',
			'#4d6476',
			'#7895ab',
			'#a8cfda',
			'#1f1a24',
			'transparent',
		]
	},

	'lucky13': {
		name: 'Lucky',
		premium: true,
		credit: [ 'SalamiChild', 'https://lospec.com/palette-list/lucky-13' ],
		p: [
			'#3a3a3a',
			'#6b6b6c',
			'#a8a8a8',
			'#e0eceb',
			'#aed0ed',
			'#888ff1',
			'#a9d71e',
			'#5aac1d',
			'#2e6b1c',
			'#ab7520',
			'#f4a30c',
			'#d9322a',
			'#ec548e',
			'transparent',
		]
	},



	'tyarcanixium13': {
		name: 'Arcanixium',
		premium: true,
		credit: [ 'Toby_Yasha', 'https://lospec.com/palette-list/ty-arcanixium-13' ],
		p: [
			'#f2f1d6',
			'#84bab4',
			'#6577aa',
			'#754a6d',
			'#ca958c',
			'#9f714a',
			'#605951',
			'#8f442f',
			'#4a3535',
			'#8f974a',
			'#50653e',
			'#324545',
			'#2a2629',
			'transparent',
		]
	},

	'fadednature13': {
		name: 'Faded Nature',
		premium: true,
		credit: [ 'ShinyTseul', 'https://lospec.com/palette-list/faded-nature-13' ],
		p: [
			'#66382e',
			'#2d4d26',
			'#5d804d',
			'#b3955a',
			'#995c3d',
			'#992e2e',
			'#383159',
			'#394c73',
			'#4d7f99',
			'#adbdcc',
			'#828499',
			'#5c5766',
			'#19161a',
			'transparent',
		]
	},

	'robotic': {
		name: 'Robotic',
		premium: false,
		credit: [ 'Floatingtable Studios', 'https://lospec.com/palette-list/robotic' ],
		p: [
			'#1d0f1d',
			'#342537',
			'#3c3748',
			'#4b5162',
			'#5f667b',
			'#708393',
			'#3b1716',
			'#8a3b06',
			'#fadd93',
			'#d4ad6a',
			'#c02811',
			'#f6a79b',
			'#f7f7f4',
			'transparent',
		]
	},

	'hydrangea11': {
		name: 'Hydrangea',
		premium: true,
		credit: [ `Dinchen\'s Art`, 'https://lospec.com/palette-list/hydrangea-11' ],
		p: [
			'#413652',
			'#6f577e',
			'#986f9c',
			'#c090a7',
			'#d4beb8',
			'#eae4dd',
			'#c9d4b8',
			'#90c0a0',
			'#6f919c',
			'#62778c',
			'#575f7e',
			'transparent',
		]
	},

	'70szine': {
		name: '70s Zine',
		premium: true,
		credit: [ 'Polyducks', 'https://lospec.com/palette-list/70s-zine' ],
		p: [
			'#1e1610',
			'#d3ad8b',
			'#fcce8d',
			'#f3ede3',
			'#f95142',
			'#ff8f46',
			'#f2bb4e',
			'#84a3a5',
			'#4d7c71',
			'#405987',
			'#1f2f49',
			'transparent',
		]
	},

	'sherbertshark': {
		name: 'Shark',
		premium: false,
		credit: [ 'Polyducks', 'https://lospec.com/palette-list/sherbert-shark' ],
		p: [
			'#dde4e8',
			'#ffc97a',
			'#8dc196',
			'#5a6e93',
			'#301c44',
			'#ce2f7f',
			'#ef8a6e',
			'#514cad',
			'#877aff',
			'transparent',
		]
	},

	// '': {
	// 	name: '',
	// 	premium: true,
	// credit: [ '', '' ],
	// 	p: [
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'transparent',
	// 	]
	// },

};


let settingsPalette = paletteLibrary.default.p;


/**
 * Make sure to change the size in the CSS as well.
 *
 * @use ../../styles/app-emoji-art.scss
 */

const newArtSize = 0;
const artSize = [ 10, 12, 14, 16 ];


/**
 * Default emoji art.
 *
 * @param {number} artSizeID The art size ID.
 * @return {array}
 */
const defaultEmojiArt = function( artSizeID = 0 ) {

	const size = artSize[ artSizeID ];

	let newArray = [];
	for ( let y = 0; y < size; y++ ) {
		newArray[ y ] = Array( size ).fill( '🟨' );
	}

	return newArray;

};


/**
 * The Reef data object.
 *
 * @type {object}
 * @property {number} height The height of the art.
 * @property {number} width The width of the art.
 * @property {array} art The emoji art.
 * @property {string} currentEmoji The current emoji.
 * @property {number} currentArtSize The current art size ID.
 * @property {string} paletteSearch The search string for the palette.
 * @property {number} backgroundColor The background color ID.
 * @property {string} size The size of the art.
 */
const ninjaData = new Reef(
	null,
	{
		data: {
			height: artSize[ newArtSize ],
			width: artSize[ newArtSize ],
			art: defaultEmojiArt( newArtSize ),
			currentEmoji: '🟪',
			currentArtSize: newArtSize,
			paletteSearch: '',
			backgroundColor: 4,
			size: 'square',
		},
		lagoon: true,
	}
);


const drawing = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Is the mouse pressed down or not?
	 *
	 * @type {boolean}
	 */
	mousepressed: false,


	/**
	 * Should we update the page url?
	 *
	 * @type {timer}
	 */
	updateUrl_timer: null,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.querySelector( '.emoji-drawing' );

		drawing.app = new Reef(
			$comp,
			{
				data: ninjaData.data,
				template: drawing.template,
				attachTo: [ ninjaData ]
			}
		);

		drawing.load();

		ninjaData.render();

		// $comp.addEventListener( 'click', drawing.click );
		$comp.addEventListener( 'mouseover', drawing.mouseover );
		$comp.addEventListener( 'mousedown', drawing.mousedown );
		document.addEventListener( 'mouseup', drawing.mouseup );
		document.addEventListener( 'reef-set-data', drawing.maybeUpdateUrl );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		const { width, height } = props;
		const size = dimensions[ props.size ].size;

		const maxGridSize = Math.max( props.height, props.width );
		const fontSize = Math.floor( ( Math.min( size[ 0 ], size[ 1 ] ) - 40 ) / maxGridSize );
		const elementType = 'button';

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				html += `<${elementType}
					class="button ghost"
					type="button"
					data-x="${x}"
					data-y="${y}"
					style="width:${fontSize}px; height:${fontSize}px;"
				>${props.art[ y ][ x ]}</${elementType}>`;

			}
		}

		// const stylesWrapper = `width:${size[ 0 ]}px; height:${size[ 1 ]}px; background-color:${settingsPalette[ props.backgroundColor ]};`;
		const stylesWrapper = [
			`width: ${size[ 0 ]}px`,
			`aspect-ratio: ${size[ 0 ]} / ${size[ 1 ]}`,
			`background-color: ${settingsPalette[ props.backgroundColor ]}`
		];
		const stylesGrid = [
			`font-size: ${fontSize - 2}px`,
			`width: ${props.width * fontSize}px`,
			`line-height: 1`,
			`height: ${props.height * fontSize}px`
		];
		// const stylesGrid = `font-size:1.5em; width:${props.width * fontSize}px; height:${props.height * fontSize}px;`;

		// Change the CSS variables so that the grid is sized correctly.
		const $styleWrapper = document.querySelector( '.emoji-drawing' );
		$styleWrapper.style.setProperty( '--emoji-col-count', width );
		$styleWrapper.style.setProperty( '--emoji-row-count', height );

		return `
		<div id="emoji-art-drawing" class="drawing m-auto overflow-hidden" style="${stylesWrapper.join( '; ' )}">
			<div class="drawing-grid grid gap0" style="${stylesGrid.join( '; ' )}">${html}</div>
		</div>`;

	},


	/**
	 * Load artwork from the url query string.
	 *
	 * @return {void}
	 */
	load: function() {

		// If there's no query string then stop loading.
		let urlParams = new URLSearchParams( window.location.search );
		if ( !urlParams.has( 'l' ) ) {
			return;
		}

		let artList = LZString.decompressFromEncodedURIComponent( urlParams.get( 'l' ) );
		let size = parseInt( urlParams.get( 's' ) );
		let backgroundColor = urlParams.get( 'bg' );

		if ( !artList ) {
			return;
		}

		if ( !size || !artSize[ size ] ) {
			size = 0;
		}

		let newArt = defaultEmojiArt( size );

		const width = artSize[ size ];
		const height = artSize[ size ];
		const currentArtSize = size;

		// @see https://stackoverflow.com/questions/24531751/how-can-i-split-a-string-containing-emoji-into-an-array
		const newLayout = drawing.emojiStringToArray( artList );

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				let e = newLayout.shift();
				if ( drawing.emojiExists( e ) ) {
					newArt[ y ][ x ] = e;
				}

			}
		}

		// Update the data.
		ninjaData.setData(
			{
				width,
				height,
				currentArtSize,
				art: newArt,
				backgroundColor
			}
		);

		undo.reset();

	},


	/**
	 * Generate a serialized string containing all the emojis from the artwork.
	 *
	 * @return {string}
	 */
	emojiArtString: function() {

		let str = '';
		const { width, height, art } = ninjaData.data;

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {
				str += art[ y ][ x ];
			}
		}

		return str;

	},


	/**
	 * Convert a string of emojis to an array of emojis, and remove empty
	 * instances.
	 *
	 * @param {string} str The string of emojis
	 * @return {array}
	 */
	emojiStringToArray: function( str ) {

		if ( !str ) {
			return [];
		}

		const emojiRegex = drawing.emojiRegex();
		const split_str = str.match( emojiRegex );

		// /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
		// const split_str = str.match( /\p{Emoji}/gu );

		let arr = [];

		for ( var i = 0; i < split_str.length; i++ ) {
			let char = split_str[ i ];

			/**
			 * Ignore empty strings and 65039.
			 * Who knows what 65039 is? I don't but it seems to be inserting
			 * itself sometimes so we have to ignore it.
			 */
			if ( char.trim() !== '' && char.charCodeAt() !== 65039 ) {
				arr.push( char );
			}
		}

		return arr;

	},


	/**
	 * Create an emoji regex for splitting the Graphemes.
	 *
	 * Based on the code from here:
	 * @see https://github.com/nota/split-graphemes/blob/master/src/emoji.js
	 * and
	 * @see https://github.com/nota/split-graphemes/blob/master/src/index.js
	 *
	 * @return {object} The regex object for finding the emoji.
	 */
	emojiRegex: function() {

		const countryFlag = '[\\u{1F1E6}-\\u{1F1FF}]{2}';
		const keyCap = '[0-9#\\*][\\u{FE0F}]?\\u{20E3}';

		const emojiRange = [
			'[\\u{2600}-\\u{26FF}]', // Miscellaneous Symbols
			'[\\u{2700}-\\u{27BF}]', // Dingbats
			'[\\u{1F300}-\\u{1F5FF}]', // Miscellaneous Symbols and Pictographs
			'[\\u{1F600}-\\u{1F64F}]', // Emoticons
			'[\\u{1F680}-\\u{1F6FF}]', // Transport and Map Symbols
			'[\\u{1F700}-\\u{1F77F}]', // Alchemical Symbols
			'[\\u{1F900}-\\u{1F9FF}]' // Supplemental Symbols and Pictographs
		];

		const emoji = `(${emojiRange.join( '|' )})`;
		const zeroWidthJoinder = '\\u{200D}';
		const variationSeletor = '[\\u{FE0E}\\u{FE0F}]';
		const skinTone = '[\\u{1F3FB}-\\u{1F3FF}]'

		const emojiVariation = `${emoji}(${zeroWidthJoinder}${emoji}|${skinTone}|${variationSeletor})*`;

		const patterns = [ countryFlag, keyCap, emojiVariation, '.' ];

		return new RegExp( `(${patterns.join( '|' )})`, 'gu' );

	},


	/**
	 * Check to see if an emoji is in the list of available emojis.
	 *
	 * @param {string} emoji The emoji to check.
	 * @return {boolean}
	 */
	emojiExists: function( emoji ) {

		let exists = false;

		emojiListFull.forEach(
			( current ) => {
				if ( current.e === emoji ) {
					exists = true;
					return;
				}
			}
		);

		return exists;

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		e.stopPropagation();
		e.preventDefault();

		const target = e.target;

		if ( 'button' !== target.localName ) {
			return;
		}

		let art = ninjaData.data.art.clone();

		const x = parseInt( target.getAttribute( 'data-x' ) );
		const y = parseInt( target.getAttribute( 'data-y' ) );

		art[ y ][ x ] = ninjaData.data.currentEmoji;

		ninjaData.setData(
			{
				art
			}
		);

		undo.add();

		document.activeElement.blur();

	},


	/**
	 * Should we update the url?
	 * Debounce so it's not firing rapidly whilst drawing.
	 *
	 * @return {void}
	 */
	maybeUpdateUrl: function() {

		// console.log( 'maybeUpdateUrl' );

		// Debounce the update.
		clearTimeout( drawing.updateUrl_timer );
		drawing.updateUrl_timer = setTimeout( drawing.updateUrl, 750 );

	},


	/**
	 * Actually update the url with the art as a string so it can be displayed.
	 *
	 * @return {void}
	 */
	updateUrl: function() {

		// console.log( 'updateUrl' );

		const url = window.location.origin + window.location.pathname;

		const params = new URLSearchParams(
			{
				bg: ninjaData.data.backgroundColor,
				sz: ninjaData.data.size,
				s: ninjaData.data.currentArtSize,
				l: LZString.compressToEncodedURIComponent( drawing.emojiArtString() ),
			}
		);

		history.replaceState( null, '', url + '?' + params.toString() );

	},


	/**
	 * Move mouse over the canvas.
	 *
	 * @return {void}
	 */
	mouseover: function( e ) {

		if ( !drawing.mousepressed ) {
			return;
		}

		drawing.click( e );

	},


	/**
	 * Click on the canvas.
	 *
	 * @return {void}
	 */
	mousedown: function( e ) {

		drawing.mousepressed = true;
		drawing.click( e );

	},


	/**
	 * Release mouse on the canvas.
	 *
	 * @return {void}
	 */
	mouseup: function( e ) {

		drawing.mousepressed = false;
		ninjaEvent( 'updateDrawing' );

	},


	/**
	 * Get a unique list of the emojis used in the drawing.
	 *
	 * @return {array}
	 */
	getArtEmojis: function() {

		const art = ninjaData.data.art;
		const { width, height } = ninjaData.data;

		let all_emojis = [];
		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				all_emojis.push( art[ y ][ x ] );

			}
		}

		return all_emojis.unique().sort();

	},

};


const exportEmojiArt = {

	/**
	 * The text to display on the copy button.
	 *
	 * @type {string}
	 */
	clipboardLinkText: '',


	/**
	 * The text to display on the copy button.
	 *
	 * @type {string}
	 */
	clipboardArtText: '',


	/**
	 * The clipboard reset timeout.
	 *
	 * @type {object|null}
	 */
	clipboardTimeoutArt: null,


	/**
	 * The clipboard reset timeout.
	 *
	 * @type {object|null}
	 */
	clipboardTimeoutLink: null,


	/**
	 * Init the export settings.
	 *
	 * @return {void}
	 */
	init: function() {

		const share_button = document.getElementById( 'share-emoji-art' );
		share_button.addEventListener( 'click', exportEmojiArt.showModal );

		const download_button = document.getElementById( 'export-image' );
		download_button.addEventListener( 'click', exportEmojiArt.exportImage );

		const clipboard_art_button = document.getElementById( 'export-clipboard-art' );
		clipboard_art_button.addEventListener( 'click', exportEmojiArt.copyArtToClipboard );
		exportEmojiArt.clipboardArtText = clipboard_art_button.innerHTML;

		const clipboard_link_button = document.getElementById( 'export-clipboard-link' );
		clipboard_link_button.addEventListener( 'click', exportEmojiArt.copyLinkToClipboard );
		exportEmojiArt.clipboardLinkText = clipboard_link_button.innerHTML;

		const twitter_button = document.getElementById( 'export-twitter' );
		twitter_button.addEventListener( 'click', exportEmojiArt.shareTwitter );

	},


	/**
	 * Display the sharing modal.
	 *
	 * @param {object} e The click event that triggers the modal.
	 * @return {void}
	 */
	showModal: function( e ) {

		e.preventDefault();

		modal.show( '#modal-export' );

		setTimeout(
			() => {
				const shareContainer = document.getElementById( 'social-share' );
				shareContainer.innerHTML = shareModal.template( '', false );
			},
			100
		);

	},


	/**
	 * Copy the current emoji art to the clipboard.
	 *
	 * @param {object} e The click event that triggers the copy.
	 * @return {void}
	 */
	copyArtToClipboard: function() {

		const clipboard_button = document.getElementById( 'export-clipboard-art' );
		exportEmojiArt.clipboardText = clipboard_button.innerHTML;
		clipboard_button.innerHTML = '✅ Copied';

		clearTimeout( exportEmojiArt.clipboardTimeoutArt );

		exportEmojiArt.clipboardTimeoutArt = setTimeout(
			() => {
				clipboard_button.innerHTML = exportEmojiArt.clipboardArtText;
			},
			1250
		);

		// https://github.com/lgarron/clipboard-polyfill
		navigator.clipboard.writeText( exportEmojiArt.getEmojiArtAsText() + '#brushninja' );

	},


	/**
	 * Copy the current link to the clipboard.
	 *
	 * @param {object} e The click event that triggers the copy.
	 * @return {void}
	 */
	copyLinkToClipboard: function() {

		const clipboard_button = document.getElementById( 'export-clipboard-link' );
		exportEmojiArt.clipboardText = clipboard_button.innerHTML;
		clipboard_button.innerHTML = '✅ Copied';

		clearTimeout( exportEmojiArt.clipboardTimeoutLink );

		exportEmojiArt.clipboardTimeoutLink = setTimeout(
			() => {
				clipboard_button.innerHTML = exportEmojiArt.clipboardLinkText;
			},
			1250
		);

		// https://github.com/lgarron/clipboard-polyfill
		navigator.clipboard.writeText( window.location.href );

	},


	/**
	 * Get the emoji art as a text string with line breaks for easy sharing on
	 * social media/ clipboard.
	 *
	 * @return {string}
	 */
	getEmojiArtAsText: function() {

		const { width, height, art } = ninjaData.data;

		let text = '';
		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {
				text += art[ y ][ x ];
			}
			text += '\n';
		}

		return text;

	},


	/**
	 * Save the current emoji art as an image.
	 *
	 * @param {object} e The click event that triggers the save.
	 * @return {void}
	 */
	exportImage: function( e ) {

		e.preventDefault();

		const wrapper = document.querySelector( '#emoji-art-drawing .drawing-grid' );
		wrapper.style.lineHeight = 0;
		const canvasScale = Math.min( window.devicePixelRatio, 1.5 );
		// const canvasScale = 1;

		html2canvas(
			document.getElementById( 'emoji-art-drawing' ),
			{
				backgroundColor: null,
				scale: canvasScale,
			}
		).then(
			( canvas ) => {

				const src = canvas.toDataURL( 'image/png' );
				downloadLink( 'emoji-art.png', src );
				// wrapper.style.transform = '';
				wrapper.style.lineHeight = 1;

			}
		);

	},


	/**
	 * Share the current emoji art on Twitter.
	 *
	 * @param {object} e The click event that triggers the share.
	 * @return {void}
	 */
	shareTwitter: function( e ) {

		const text = exportEmojiArt.getEmojiArtAsText();

		const share_url = twitterShare( text );//, window.location.origin + window.location.pathname );

		window.open( share_url, '_blank' );

	},

};
const palette = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * List of emojis to display.
	 *
	 * @type {array}
	 */
	emoji: [ '⬜️', '⬛️', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '🟫', '🔲', '🔳' ],


	/**
	 * Emojis to block/ exclude.
	 *
	 * @type {array}
	 */
	emoji_exclude: [ '🖕', '🖕🏻', '🖕🏼', '🖕🏽', '🖕🏾', '🖕🏿' ],


	/**
	 * An array of emoji categories.
	 *
	 * @type {array}
	 */
	emoji_categories: null,


	/**
	 * The search element.
	 *
	 * @type {object}
	 */
	$search: null,


	/**
	 * Debounce the search queries.
	 *
	 * @type {null|object}
	 */
	searchTimer: null,


	/**
	 * Fuzzy search.
	 *
	 * @type {object}
	 */
	fuse: null,


	/**
	 * Debounce the drawing updates.
	 *
	 * @type {null|object}
	 */
	timerUpdateDrawing: null,


	/**
	 * A list of the colours in the drawing.
	 *
	 * @type {array}
	 */
	drawingPalette: [],


	/**
	 * Count the items in the emoji categories.
	 *
	 * @type {array}
	 */
	groupCount: [],


	/**
	 * Initialize the component.
	 *
	 * @return {void}
	 */
	init: function() {

		// Remove palette.emoji_exclude from emojiListFull.
		emojiListFull = emojiListFull.filter( item => !palette.emoji_exclude.includes( item.e ) );

		// Initialize the fuzzy search.
		palette.fuse = new Fuse(
			emojiListFull,
			{
				keys: [ 'n' ],
				minMatchCharLength: 2,
				threshold: 0.2,
			}
		);

		emojiListFull.forEach(
			( item ) => {
				if ( palette.groupCount[ item.g ] ) {
					palette.groupCount[ item.g ]++;
				} else {
					palette.groupCount[ item.g ] = 1;
				}
			}
		);

		const $comp = document.querySelector( '.emoji-palette' );

		palette.app = new Reef(
			$comp,
			{
				data: {
					paletteSearch: '',
				},
				template: palette.template,
			}
		);

		palette.app.render();

		$comp.addEventListener( 'click', palette.click );

		palette.$search = document.getElementById( 'palette-search' );
		palette.$search.addEventListener( 'keyup', palette.searchChange );

		document.addEventListener( 'updateDrawing', palette.maybeUpdateDrawing );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		html += palette.emoji_picker_categories();
		html += '<section class="w100 flex-g1">';
		html += palette.emoji_picker_search();
		html += palette.emoji_picker_list( ninjaData.data.currentEmoji );
		html += '</section>';

		return html;

	},


	/**
	 *
	 */
	emoji_picker_search: function() {

		let html = '';

		html += `<input
			type="search"
			placeholder="Search..."
			id="palette-search"
			class="mw5"
			results="5"
			value="${palette.app.data.paletteSearch}"
		/>`;

		return `<div class="position-s p3">${html}</div>`;

	},


	/**
	 * List the emoji picker categories.
	 *
	 * @return {string}
	 */
	emoji_picker_categories: function() {

		let html = '';

		// Add the non category links.
		html += palette.emojiCategoryLinkHTML( 'This Image' );
		html += palette.emojiCategoryLinkHTML( 'Pixel Art' );

		// Add the actual category links.
		emojiGroups.forEach(
			( item, index ) => {
				if ( palette.groupCount[ index ] > 0 ) {
					html += palette.emojiCategoryLinkHTML( item );
				}
			}
		);

		return `<nav
			class="p3 flex flex-wrap w3"
		>${html}</nav>`;

	},


	/**
	 * Display the list of emojis.
	 *
	 * @param {string} currentEmoji The currently selected emoji.
	 * @return {string} The html for the emoji list.
	 */
	emoji_picker_list: function( currentEmoji ) {

		let html = '';

		const { paletteSearch } = palette.app.data;

		// Is there a search happening?
		if ( paletteSearch ) {

			const searchResults = palette.fuse.search( paletteSearch );

			if ( searchResults.length <= 0 ) {

				// No search results.
				html += `<strong class="display-block m-t3">Can't find emojis for <em>"${sanitize.html( paletteSearch )}</em>".</strong>`;

			} else {

				// Display Search Results.
				searchResults.forEach(
					( value ) => {
						// console.log( value );
						html += palette.emojiButtonHTML( value.item, currentEmoji );
					}
				);

			}

		} else {

			if ( palette.drawingPalette.length <= 0 ) {
				palette.updateDrawingPalette();
			}

			html += palette.displayEmojiGroup( 'This Image', currentEmoji, null, palette.drawingPalette );
			html += palette.displayEmojiGroup( 'Pixel Art', currentEmoji, null, palette.emoji );

			// Default Emoji List.
			emojiGroups.forEach(
				( item, group_index ) => {

					html += palette.displayEmojiGroup( item, currentEmoji, group_index );

				}
			);

		}

		return `<div
			id="emoji-list"
			class="p3 mh6 overflow scroll-smooth flex-g1"
		>${html}</div>`;

	},


	/**
	 * Display a group of emojis with heading.
	 * Generates the required html.
	 *
	 * @param {string} name The name of the group. Slugified this is also the group array key.
	 * @param {string} currentEmoji The current emoji.
	 * @param {string} group_index The current group to display.
	 * @param {array} emoji_list The list of emojis to display.
	 * @return {string} The html for the emoji group.
	 */
	displayEmojiGroup: function( name, currentEmoji, group_index = null, emoji_list = emojiListFull ) {

		let html = '';

		if ( null !== group_index ) {
			if ( !palette.groupCount[ group_index ] || palette.groupCount[ group_index ] <= 0 ) {
				return html;
			}
		}

		const slug = urlString( name );

		// Category heading.
		html += `<strong
			id="category-${slug}"
			class="display-block m-t3"
		>${name}</strong>`;

		// Loop through all emoji.
		emoji_list.forEach(
			( value, index ) => {

				if ( undefined === value.g ) {
					value = {
						e: value,
						n: '',
						g: group_index
					};
				}

				if ( group_index === value.g ) {
					html += palette.emojiButtonHTML( value, currentEmoji );
				}

			}
		);

		return html;

	},


	/**
	 * Generate a link that points to a category in the emoji list.
	 *
	 * @param {string} category The category name to link to.
	 * @return {string} The link html.
	 */
	emojiCategoryLinkHTML: function( category ) {

		const slug = urlString( category );

		return `<a
			href="#category-${slug}"
			data-id="${slug}"
			class="w2 flex-g1"
			title="Emojis for ${category}"
		>
			<img src="/assets/images/emoji-categories/${slug}.svg" alt="*" />
		</a>`;

	},


	/**
	 * Display a category button.
	 *
	 * @param {object} emoji Information about the current emoji.
	 * @param {string} currentEmoji The currently selected emoji.
	 * @return {string} The button html.
	 */
	emojiButtonHTML: function( emoji, currentEmoji ) {

		let buttonClass = '';

		if ( emoji.e === currentEmoji ) {
			buttonClass = 'selected';
		}

		return `<button
			data-emoji="${emoji.e}"
			type="button"
			title="${emoji.n}"
			class="ar-1 button button-emoji ${buttonClass}">${emoji.e}</button>`;

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		e.preventDefault();
		e.stopPropagation();

		const htmlType = e.target.nodeName;

		/**
		 * Category anchors.
		 */
		if ( 'A' === htmlType ) {

			/**
			 * When we click a category link lets clear the search box to ensure
			 * the selected category is visible.
			 */
			palette.app.setData(
				{
					paletteSearch: ''
				}
			);

			document.getElementById( 'palette-search' ).value = '';

			const href = e.target.getAttribute( 'href' );
			scrollToTop( document.querySelector( href ), document.querySelector( '.emoji-palette div#emoji-list' ) );
			return;

		}

		if ( 'BUTTON' !== htmlType ) {
			return;
		}

		/**
		 * Update the currently selected emoji.
		 */
		const target = e.target;
		const emoji = target.getAttribute( 'data-emoji' );

		if ( !emoji ) {
			return;
		}

		ninjaData.setData(
			{
				currentEmoji: emoji
			}
		);

		palette.app.render();

	},


	/**
	 * Debounce the search engine changes.
	 *
	 * @param {event} e The event changes.
	 * @return {void}
	 */
	searchChange: function( e ) {

		clearTimeout( palette.searchTimer );
		palette.searchTimer = setTimeout( palette.searchEmoji, 400 );

	},


	/**
	 * Change the current search parameters.
	 *
	 * @return {void}
	 */
	searchEmoji: function() {

		const query = palette.$search.value.toLowerCase();

		palette.app.setData(
			{
				'paletteSearch': query
			}
		);

	},


	/**
	 * Debounce palette updates.
	 *
	 * @param {event} e The listener event.
	 * @return {void}
	 */
	maybeUpdateDrawing: function( e ) {

		clearTimeout( palette.timerUpdateDrawing );
		palette.timerUpdateDrawing = setTimeout( palette.updateDrawingPalette, 1000 );

	},


	/**
	 * Update the drawing palette if it has changed.
	 *
	 * @return {void}
	 */
	updateDrawingPalette: function() {

		const tempPalette = drawing.getArtEmojis();

		if ( JSON.stringify( tempPalette ) !== JSON.stringify( palette.drawingPalette ) ) {
			palette.drawingPalette = tempPalette;
			palette.app.render();
		}

	},

};

const undo = {

	history: [],

	redoHistory: [],


	/**
	 * Add the current emoji art to the undo history.
	 * @return {void}
	 */
	add: function() {

		undo.history.push( undo.getArt() );
		undo.redoHistory = [];

		// Limit to 100 undo steps.
		if ( undo.history.length > 100 ) {
			undo.history.shift();
		}

	},


	/**
	 * Reset the undo history.
	 *
	 * @return {void}
	 */
	reset: function() {

		undo.history = [];
		undo.redoHistory = [];

		undo.add();

	},


	/**
	 * Undo the last action.
	 *
	 * @return {void}
	 */
	undo: function() {

		if ( undo.history.length > 0 ) {
			const last = undo.history.pop();
			undo.redoHistory.push( undo.getArt() );
			undo.setArt( last );
		}

	},


	/**
	 * Redo the last undo.
	 *
	 * @return {void}
	 */
	redo: function() {

		if ( undo.redoHistory.length > 0 ) {
			const last = undo.redoHistory.pop();
			undo.history.push( undo.getArt() );
			undo.setArt( last );
		}

	},


	/**
	 * Get the current emoji art.
	 *
	 * @return {array}
	 */
	getArt: function() {

		const { width, height, art } = ninjaData.data;

		const newArt = [];
		for ( let y = 0; y < height; y++ ) {
			newArt[ y ] = [];
			for ( let x = 0; x < width; x++ ) {
				newArt[ y ][ x ] = art[ y ][ x ];
			}
		}

		return newArt;

	},


	/**
	 * Set the current emoji art.
	 *
	 * @param {array} newArt
	 * @return {void}
	 */
	setArt: function( newArt ) {

		ninjaData.setData(
			{
				art: newArt,
			}
		);

	}

};
const app = {

	/**
	 * Initialize the app.
	 *
	 * @return {void}
	 */
	init: function() {

		const resetButton = document.getElementById( 'reset' );
		resetButton.addEventListener( 'click', app.clickReset );

		const colorButton = document.getElementById( 'change-colour' );
		colorButton.addEventListener( 'click', app.clickChangeColour );

		// const sizeButton = document.getElementById( 'change-size' );
		// sizeButton.addEventListener( 'click', app.clickChangeSize );

		const artSizeButton = document.getElementById( 'change-size-art' );
		artSizeButton.addEventListener( 'click', app.clickChangeSizeArt );

		const undoButton = document.getElementById( 'undo' );
		undoButton.addEventListener( 'click', undo.undo );

		const redoButton = document.getElementById( 'redo' );
		redoButton.addEventListener( 'click', undo.redo );

		document.addEventListener(
			'reef-set-data',
			() => {
				app.updateButtons();
			}
		);

		setTimeout( app.updateButtons, 1000 );

	},


	/**
	 * Change the background color.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeColour: function( e ) {

		e.preventDefault();

		let currentPalette = parseInt( ninjaData.data.backgroundColor );

		currentPalette++;
		if ( 'transparent' === settingsPalette[ currentPalette ] ) {
			currentPalette++;
		}
		if ( currentPalette >= settingsPalette.length ) {
			currentPalette = 0;
		}

		ninjaData.setData(
			{
				backgroundColor: currentPalette,
			}
		);

		app.updateButtons();

	},


	/**
	 * Update the button colours.
	 *
	 * @return {void}
	 */
	updateButtons: function() {

		// Background Colour.
		const bgButton = document.getElementById( 'change-colour' );

		if ( bgButton ) {

			const currentPalette = parseInt( ninjaData.data.backgroundColor );

			bgButton.style.backgroundColor = settingsPalette[ currentPalette ];
			bgButton.style.color = tinycolor.mostReadable( settingsPalette[ currentPalette ], [ '#000', '#fff' ] );

		}

		// Drawing Size.
		// const sizeButton = document.getElementById( 'change-size-art' );

		// if ( sizeButton ) {
		// 	const currentSize = artSize[ ninjaData.data.currentArtSize ];
		// 	sizeButton.textContent = `Size [${currentSize} x ${currentSize}]`;
		// }

	},


	/**
	 * Reset the artwork to be the defaults.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickReset: function( e ) {

		e.preventDefault();

		ninjaData.setData(
			{
				art: defaultEmojiArt( ninjaData.data.currentArtSize ),
			}
		);

		undo.reset();

	},


	/**
	 * Change the frame shape and size.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeSize: function( e ) {

		e.preventDefault();

		const current = ninjaData.data.size;
		const keyList = Object.keys( dimensions );

		let keyId = keyList.findIndex(
			( value ) => {
				return value === current;
			}
		);

		keyId++;
		if ( keyId >= keyList.length ) {
			keyId = 0;
		}

		ninjaData.setData(
			{
				size: keyList[ keyId ],
			}
		);

		undo.reset();

	},


	/**
	 * Change the amount of emojis to use.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeSizeArt: function( e ) {

		e.preventDefault();

		let newArtSize = ninjaData.data.currentArtSize + 1;
		if ( newArtSize >= artSize.length ) {
			newArtSize = 0;
		}

		// Make sure we don't try to copy more than the new size.
		let oldSize = Math.min( artSize[ ninjaData.data.currentArtSize ], artSize[ newArtSize ] );

		let newArt = defaultEmojiArt( newArtSize );
		const art = ninjaData.data.art;

		// Copy the old art to the new art so we lose as little as possible.
		for ( let y = 0; y < oldSize; y++ ) {
			for ( let x = 0; x < oldSize; x++ ) {
				newArt[ y ][ x ] = art[ y ][ x ] + '';
			}
		}

		// Update the data.
		ninjaData.setData(
			{
				height: artSize[ newArtSize ],
				width: artSize[ newArtSize ],
				art: newArt,
				currentArtSize: newArtSize,
			}
		);

		undo.reset();

	},

};


; (
	function() {

		'use strict';

		ready(

			function() {

				app.init();
				drawing.init();
				palette.init();
				exportEmojiArt.init();

			}

		);

	}
)();

